import { createContext } from 'react'

import { CookieHandler } from './types'

export const CookieManagerContext = createContext<CookieHandler | null>(null)
